import { render } from "./MyStages.vue?vue&type=template&id=2fccb88e&scoped=true"
import script from "./MyStages.vue?vue&type=script&lang=js"
export * from "./MyStages.vue?vue&type=script&lang=js"

import "./MyStages.vue?vue&type=style&index=0&id=2fccb88e&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fccb88e"]])

export default __exports__